/**
 * Dekorova — Simple Custom Options (non-M² products)
 *
 * Intercepts Dawn's fetch /cart/add to inject line-item properties
 * from inputs outside the <form> element.
 * Also validates required fields before allowing submission.
 */
(function () {
  'use strict';

  document.querySelectorAll('.dekorova-simple-options').forEach(initSimple);

  function initSimple(root) {
    var formId = root.dataset.formId;
    var form = document.getElementById(formId);
    if (!form) return;

    var productFormEl = form.closest('product-form');

    // Collect input references
    var elEn = root.querySelector('.dekorova-simple-opt__en');
    var elBoy = root.querySelector('.dekorova-simple-opt__boy');
    var elKartela = root.querySelector('.dekorova-simple-opt__kartela');
    var zincirName = root.dataset.zincirName || '';

    // Monkey-patch window.fetch to inject properties
    var origFetch = window.fetch;
    window.fetch = function (url, options) {
      if (
        typeof url === 'string' &&
        url.indexOf('/cart/add') !== -1 &&
        options && options.body instanceof FormData
      ) {
        var formDataId = options.body.get('id');
        var ourVariantId = form.querySelector('input.product-variant-id');
        if (ourVariantId && formDataId === ourVariantId.value) {
          injectProperties(options.body);
        }
      }
      return origFetch.apply(this, arguments);
    };

    // Validation on form submit (capture phase)
    form.addEventListener('submit', function (e) {
      var errors = [];

      if (elEn && !elEn.value.trim()) {
        errors.push('En');
        elEn.classList.add('dekorova-simple-opt--error');
      }
      if (elBoy && !elBoy.value.trim()) {
        errors.push('Boy');
        elBoy.classList.add('dekorova-simple-opt--error');
      }
      if (elKartela && elKartela.dataset.required === 'true' && !elKartela.value.trim()) {
        errors.push('Kartela Kodu');
        elKartela.classList.add('dekorova-simple-opt--error');
      }
      if (zincirName) {
        var checked = root.querySelector('input[name="' + zincirName + '"]:checked');
        if (!checked) {
          errors.push('Zincir Yönü');
        }
      }

      if (errors.length > 0) {
        e.preventDefault();
        e.stopImmediatePropagation();
        if (productFormEl && productFormEl.handleErrorMessage) {
          productFormEl.handleErrorMessage('Lütfen gerekli alanları doldurunuz: ' + errors.join(', '));
        }
        return false;
      }
    }, true);

    // Clear error styling on input
    root.addEventListener('input', function (e) {
      e.target.classList.remove('dekorova-simple-opt--error');
      if (productFormEl && productFormEl.handleErrorMessage) {
        productFormEl.handleErrorMessage();
      }
    });

    function injectProperties(formData) {
      if (elEn && elEn.value.trim()) {
        formData.set('properties[En]', elEn.value.trim() + ' cm');
      }
      if (elBoy && elBoy.value.trim()) {
        formData.set('properties[Boy]', elBoy.value.trim() + ' cm');
      }
      if (elKartela && elKartela.value.trim()) {
        formData.set('properties[Kartela Kodu]', elKartela.value.trim());
      }
      if (zincirName) {
        var checked = root.querySelector('input[name="' + zincirName + '"]:checked');
        if (checked) {
          formData.set('properties[Zincir Yönü]', checked.value);
        }
      }
    }
  }
})();
